import axios from 'axios';
import { Region } from '../models/Region';

export class RegionService {

    async getAllRegions(): Promise<Region[]> {
        try {
            const response = await axios.post('getAllRegions', {
            });

            return response.data;
        } catch (error) {
            throw new Error("Error: " + error);
        }
    }
}